import { AxiosResponse, HttpStatusCode } from 'axios';
import { PartnerBusinessInfoForm } from './PartnerBusinessDetails';
import { PartnerPersonalFormData } from './PartnerPersonalInfo';
import { PartnerContractFormData } from './PartnerContract';

export const patchPartner = async (
  formData: PartnerBusinessInfoForm,
  partner_id: string,
  callProtectedApi: (
    url: string,
    requestType: string,
    body?: any,
    errorMsg?: string | undefined,
    newHeaders?: any,
    domain?: string | undefined,
    retries?: number
  ) => Promise<AxiosResponse<any, any> | null>,
  setLoading: (loading: boolean) => void,
  setStep: (newStep: string) => void,
  nextStep: string
) => {
  try {
    setLoading(true);
    const response = await callProtectedApi(
      `/partners/${partner_id}`,
      'patch',
      {
        address_st_number: formData?.address_st_number,
        address_st_name: formData?.address_st_name,
        address_unit: formData?.address_unit,
        address_city: formData?.address_city,
        address_state: formData?.address_state,
        address_zip: formData?.address_zip,
        business_name: formData?.businessName,
        website_url: formData?.websiteUrl,
        business_phone_number: formData?.businessPhone,
        description_of_services: formData?.descriptionOfServices,
        mc_number: formData?.mcNumber,
        ein_number: formData?.einNumber,
        partner_signup_step: nextStep,
      }
    );
    const partner = response?.data?.data?.partner;
    if (
      partner &&
      Object.entries(partner)?.length > 0 &&
      response?.status === HttpStatusCode.Ok
    ) {
      setStep(nextStep);
    }
  } catch (e: any) {
    console.error('Error occurred while updating partner record: ', e);
    return null;
  } finally {
    setLoading(false);
  }
};

export const updatePartnerSignupStep = async (
  partner_id: string,
  callProtectedApi: (
    url: string,
    requestType: string,
    body?: any,
    errorMsg?: string | undefined,
    newHeaders?: any,
    domain?: string | undefined,
    retries?: number
  ) => Promise<AxiosResponse<any, any> | null>,
  setLoading: (loading: boolean) => void,
  setStep: (newStep: string) => void,
  nextStep: string
) => {
  try {
    setLoading(true);
    const response = await callProtectedApi(
      `/partners/${partner_id}`,
      'patch',
      {
        partner_signup_step: nextStep,
      },
      'Error occurred while updating your application.'
    );
    const partner = response?.data?.data?.partner;
    if (
      partner &&
      Object.entries(partner)?.length > 0 &&
      response?.status === HttpStatusCode.Ok
    ) {
      setStep(nextStep);
    }
  } catch (e: any) {
    console.error(
      'Error occurred while updating partner record signup step: ',
      e
    );
    return null;
  } finally {
    setLoading(false);
  }
};

export const createPartnerContactInfo = async (
  formData: PartnerPersonalFormData,
  partner_id: string,
  callProtectedApi: (
    url: string,
    requestType: string,
    body?: any,
    errorMsg?: string | undefined,
    newHeaders?: any,
    domain?: string | undefined,
    retries?: number
  ) => Promise<AxiosResponse<any, any> | null>,
  setLoading: (loading: boolean) => void,
  setStep: (newStep: string) => void,
  nextStep: string
) => {
  try {
    setLoading(true);
    const response = await callProtectedApi(
      `/partnerContactInfos`,
      'post',
      {
        first_name: formData?.firstName,
        last_name: formData?.lastName,
        email: formData?.email,
        phone_number: formData?.phoneNumber,
        position: formData?.companyPosition,
        partner_id: partner_id,
      },
      'Error occurred while saving your personal information.'
    );
    const partnerContact = response?.data?.data?.partnerContactInfo;
    if (
      partnerContact &&
      Object.entries(partnerContact)?.length > 0 &&
      (response?.status === HttpStatusCode.Created ||
        response?.status === HttpStatusCode.Ok)
    ) {
      setStep(nextStep);
      return true;
    }
    return false;
  } catch (e: any) {
    console.error('Error occurred while creating partner contact info: ', e);
    return false;
  } finally {
    setLoading(false);
  }
};

export const savePartnerContract = async (
  formData: PartnerContractFormData,
  partner_id: string,
  callProtectedApi: (
    url: string,
    requestType: string,
    body?: any,
    errorMsg?: string | undefined,
    newHeaders?: any,
    domain?: string | undefined,
    retries?: number
  ) => Promise<AxiosResponse<any, any> | null>,
  setLoading: (loading: boolean) => void,
  setStep: (newStep: string) => void,
  nextStep: string
) => {
  try {
    setLoading(true);
    const response = await callProtectedApi(
      `/partners/${partner_id}`,
      'patch',
      {
        contract_signature_full_name: formData?.signatureFullName,
        contract_signature_title: formData?.signatureTitle,
        contract_signed_at: formData?.signedAt,
        contract_agreement_accepted: formData?.agreementChecked,
        partner_signup_step: nextStep,
      },
      'Error occurred while saving your contract signature.'
    );
    const partner = response?.data?.data?.partner;
    if (
      partner &&
      Object.entries(partner)?.length > 0 &&
      response?.status === HttpStatusCode.Ok
    ) {
      setStep(nextStep);
      return true;
    }
    return false;
  } catch (e: any) {
    console.error('Error occurred while saving partner contract: ', e);
    return false;
  } finally {
    setLoading(false);
  }
};
